module.exports = __webpack_public_path__ + "h5/img/service3.0c2fff37.png";